module.exports = __webpack_public_path__ + "img/visa.1822bb47.svg";